module.exports = {
	"header": "Se connecter",
	"facebook": "Connexion avec Facebook",
	"google": "Connexion avec Google",
	"linkedin": "Connexion avec LinkedIn",
	"register": "S'enregistrer",
	"sellerHeader": "Connexion pour les encanteurs",
	"noAccountRegister": "Vous n'avez pas de compte? <registerLink>$t(login::register) maintenant</registerLink>"
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/fr/login.json5
// module id = 1990
// module chunks = 6